var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 10,
  viewBox: "0 0 80 10",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.08403e-07 10C20 10 33 5.5 40 -3.49691e-06L40 10L20 10L8.08403e-07 10Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M80 10C60 10 47 5.5 40 3.49691e-06L40 10L60 10L80 10Z",
  fill: "currentColor"
})));
export { SvgArrowCenter as ReactComponent };